import Notifications from '@kyvg/vue3-notification';
import {
  init,
  browserTracingIntegration,
  captureException,
} from '@sentry/vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from '@/App.vue';
import { worker } from '@/mocks/worker';
import vuetify from '@/plugins/vuetify';
import router from '@/router';
import { words } from '@/tenant-data';

const {
  MODE,
  VITE_TENANT,
} = import.meta.env;

// Mock Service Worker読み込み
if (import.meta.env.MODE === 'mock') {
  await worker.start({
    serviceWorker: {
      url: '/mockServiceWorker.js',
    },
    onUnhandledRequest: 'bypass',
    waitUntilReady: false,
  });
}

const app = createApp(App);

init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    browserTracingIntegration({
      router,
      routeLabel: 'path',
    }),
  ],
  environment: `${MODE}_${VITE_TENANT}`,
  tracesSampleRate: 0.05,
  allowUrls: [
    /https:\/\/.*\.wsmt\.jp(\/.*)?/,
    /https:\/\/.*\.walletstation\.org(\/.*)?/,
    /https:\/\/.*\.s3\.amazonaws\.com(\/.*)?/,
    /https:\/\/.*\.maps\.googleapis\.com(\/.*)?/,
  ],
  denyUrls: [
    /https:\/\/.*\.google-analytics\.com(\/.*)?/,
  ],
});

app.use(router)
  .use(createPinia())
  .use(vuetify)
  .use(Notifications);

// 言語ファイルグローバル化
app.config.globalProperties.$words = words;

// 未捕捉のエラーをログに出力する
window.addEventListener('unhandledrejection', (event) => {
  captureException(event.reason);
  logger.log({ event }, 'UncaughtPromiseError');
});
window.onerror = (message, source, lineno, colno, error) => {
  captureException(error);
  logger.log({ message, source, lineno, colno, error }, 'UncaughtError');
};
app.config.errorHandler = (err, instance, info) => {
  captureException(err);
  logger.log({ err, instance, info }, 'UncaughtVueError');
};
// Vueの実行時警告をログに出力する
app.config.warnHandler = (err, instance, info) => {
  logger.log({ err, instance, info }, 'VueWarn');
};

app.mount('#app');
